"use client";

import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { MessageCircle, Mail, Heart } from "lucide-react";
import { BRAND, FOOTER } from "@/lib/marketing/copy";

export function ZaklynFooter() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground text-white">
      <div className="zaklyn-container py-16 md:py-20">
        <div className="grid md:grid-cols-4 gap-12 md:gap-8">
          <div className="md:col-span-2">
            <Link to="/" className="inline-block">
              <span className="font-display text-3xl font-semibold">
                {BRAND.name}
              </span>
            </Link>
            <p className="mt-4 text-white/70 font-body max-w-sm leading-relaxed">
              {FOOTER.tagline}
            </p>
            <div className="mt-6 flex items-center gap-4">
              <a
                href={`https://wa.me/${FOOTER.contact.whatsapp.replace(/\s/g, "")}`}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 hover:bg-white/20 rounded-xl text-sm font-medium transition-colors"
              >
                <MessageCircle className="h-4 w-4" />
                WhatsApp Us
              </a>
              <a
                href={`mailto:${FOOTER.contact.email}`}
                className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 hover:bg-white/20 rounded-xl text-sm font-medium transition-colors"
              >
                <Mail className="h-4 w-4" />
                Email
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-display text-lg font-semibold mb-4">
              Company
            </h4>
            <ul className="space-y-3">
              {FOOTER.links.company.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-white/70 hover:text-white transition-colors font-body text-sm"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display text-lg font-semibold mb-4">
              Legal
            </h4>
            <ul className="space-y-3">
              {FOOTER.links.legal.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-white/70 hover:text-white transition-colors font-body text-sm"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-white/50 text-sm font-body">
              &copy; {currentYear} {FOOTER.copyright}
            </p>
            <p className="flex items-center gap-1 text-white/50 text-sm font-body">
              Made with <Heart className="h-3.5 w-3.5 text-primary fill-primary" /> in India
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
